module.exports = __webpack_public_path__ + "img/68_44.f7d55dea.png";